
export const BRAND_ADD_REQUEST = "BRAND_ADD_REQUEST";
export const BRAND_ADD_SUCCESS = "BRAND_ADD_SUCCESS";
export const BRAND_ADD_FAILURE = "BRAND_ADD_FAILURE";

export const BRAND_EDIT_REQUEST = "BRAND_EDIT_REQUEST";
export const BRAND_EDIT_SUCCESS = "BRAND_EDIT_SUCCESS";
export const BRAND_EDIT_FAILURE = "BRAND_EDIT_FAILURE";

export const BRAND_VIEW_REQUEST = "BRAND_VIEW_REQUEST";
export const BRAND_VIEW_SUCCESS = "BRAND_VIEW_SUCCESS";
export const BRAND_VIEW_FAILURE = "BRAND_VIEW_FAILURE";

export const BRAND_VIEW_ALL_REQUEST = "BRAND_VIEW_ALL_REQUEST";
export const BRAND_VIEW_ALL_SUCCESS = "BRAND_VIEW_ALL_SUCCESS";
export const BRAND_VIEW_ALL_FAILURE = "BRAND_VIEW_ALL_FAILURE";

export const BRAND_VIEW_BY_ALCOHOL_ID_REQUEST = "BRAND_VIEW_BY_ALCOHOL_ID_REQUEST";
export const BRAND_VIEW_BY_ALCOHOL_ID_SUCCESS = "BRAND_VIEW_BY_ALCOHOL_ID_SUCCESS";
export const BRAND_VIEW_BY_ALCOHOL_ID_FAILURE = "BRAND_VIEW_BY_ALCOHOL_ID_FAILURE";

export const BRAND_SEARCH_REQUEST = "BRAND_SEARCH_REQUEST";
export const BRAND_SEARCH_SUCCESS = "BRAND_SEARCH_SUCCESS";
export const BRAND_SEARCH_FAILURE = "BRAND_SEARCH_FAILURE";

export const BRAND_DELETE_REQUEST = "BRAND_DELETE_REQUEST";
export const BRAND_DELETE_SUCCESS = "BRAND_DELETE_SUCCESS";
export const BRAND_DELETE_FAILURE = "BRAND_DELETE_FAILURE";

export const  BRAND_RESET_STATE = " BRAND_RESET_STATE";